import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';

import {
  CampaignControllerDtoWhiteListAddRequest,
  CampaignControllerDtoWhiteListRemoveRequest,
  CampaignControllerDtoPlayStoreSearchRequest,
  CampaignControllerDtoPlayStoreSearchResponse,
  CampaignControllerDtoAppListRequest,
  CampaignControllerDtoAppListResponse,
  PerplayCampaignApi,
} from '../../models/src';

import {
  WHITE_LIST_APP_ADD_REQUEST,
  WHITE_LIST_APP_REMOVE_REQUEST,
  WHITE_LIST_APP_INFO_REQUEST,
  SEARCH_APP_INFO_REQUEST,
} from '../../constants/app/whiteListAppsConstants';
import BaseResponse from '../../models/src/model/BaseResponse';

const api = new PerplayCampaignApi(config.API_CLIENT);

function* addWhiteListAppSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoWhiteListAddRequest(
      payload.packageName,
    );
    const res = yield api.apiPerplayCampaignWhiteListAddPost(
      { campaignControllerDtoWhiteListAddRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* removeWhiteListAppSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoWhiteListRemoveRequest(
      payload.packageName,
    );
    const res = yield api.apiPerplayCampaignWhiteListRemovePost(
      { campaignControllerDtoWhiteListRemoveRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(res, BaseResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* whiteListAppInfoRequestSaga(payload) {
  try {
    const requestData = new CampaignControllerDtoPlayStoreSearchRequest();
    requestData.packageName = payload.packageName;
    console.log('requestData: ', requestData);
    const res = yield api.apiPerplayCampaignPlayStoreSearchPost(
      { campaignControllerDtoPlayStoreSearchRequest: requestData },
      () => {},
    );
    console.log('result: ', res);
    const data = api.apiClient.deserialize(
      res,
      CampaignControllerDtoPlayStoreSearchResponse,
    );
    if (data.resultCode !== 200) {
      console.log(data);
      throw new Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    // console.error(e);
    if (e.message.toString().startsWith('Error:')) {
      if (payload.error) {
        payload.error(e);
      }
      return;
    }
    if (payload.error) {
      payload.error(new Error(e.status ?? e.message));
    }
  }
}

function* searchAppInfoRequestSaga(payload) {
  try {
    console.log(payload);
    const requestData = new CampaignControllerDtoAppListRequest(1, 10);
    requestData.searchString = payload.packageName;
    const res = yield api.apiPerplayCampaignAppListPost(
      { campaignControllerDtoAppListRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(
      res,
      CampaignControllerDtoAppListResponse,
    );
    console.log(data);
    if (data.resultCode !== 200) {
      console.log(data);
      throw new Error(`Error: ${data.resultCode}`);
    }

    const info = data.list.find((x) => x.packageName === payload.packageName);
    if (!info) {
      throw new Error(`Error: empty`);
    }

    if (payload.callback) {
      payload.callback(info);
    }
  } catch (e) {
    console.error(e);
    if (payload.error) {
      payload.error(e);
    }
  }
}

function* rootSaga() {
  yield all([
    takeEvery(WHITE_LIST_APP_ADD_REQUEST, addWhiteListAppSaga),
    takeEvery(WHITE_LIST_APP_REMOVE_REQUEST, removeWhiteListAppSaga),
    takeEvery(WHITE_LIST_APP_INFO_REQUEST, whiteListAppInfoRequestSaga),
    takeEvery(SEARCH_APP_INFO_REQUEST, searchAppInfoRequestSaga),
  ]);
}

const whiteListAppsSagas = [fork(rootSaga)];
export default whiteListAppsSagas;
